

define(['angular', 'text!./template.html', 'components/xo-ui-components/src/error-tooltip/directive'], function (angular, template) {

    return angular.module('xo-guest-upgrade.occupation', ['squid', 'xo-error-tooltip.directive']).directive('xoOccupation', function () {
        return {
            template: template,

            scope: {
                user: '='
            },

            controller: function controller($scope, $locale) {

                $scope.locale = $locale;

                $scope.occupations = function () {
                    return $locale.content.signup.occupationList;
                };
            }
        };
    });
});


//////////////////
// WEBPACK FOOTER
// ./components/xo-guest-components/src/guest-upgrade/occupation/directive.js
// module id = ./components/xo-guest-components/src/guest-upgrade/occupation/directive.js
// module chunks = 1